import fetch from "auth/FetchInterceptor";
import {
  ADD_REPOSITORY,
  CONTRACT_DELETE,
  CONTRACT_DETAILS,
  CONTRACT_UPDATE,
  CREATE_CONTRACTS,
  DELETE_REPOSITORY,
  GET_REPOSITORY,
  GET_REPOSITORY_SOURCES,
  ADD_RESPONSIBILITY,
  DELETE_RESPONSIBILITY,
  GET_RESPONSIBILITY,
  LIST_CONTRACTS,
  GET_OBLIGATIONS,
  ADD_OBLIGATION,
  UPDATE_OBLIGATION,
  DELETE_OBLIGATION,
  GET_OBLIGATION_DETAILS,
  GET_OBLIGATION_TASKS,
  UPDATE_OBLIGATION_PRIORITY,
  GET_SCHEDULE_TASKS,
  CREATE_SCHEDULE_TASK,
  GET_TASK_DETAILS,
  UPDATE_TASK,
  UPDATE_TASK_PRIORITY,
  DELETE_TASK,
  GET_TASK_UPDATES,
  CREATE_TASK_UPDATE,
  UPDATE_TASK_UPDATE,
  UPLOAD_TASK_UPDATE_DOCUMENTS,
  DELETE_TASK_UPDATE_DOCUMENT,
  GET_MILESTONES,
  CREATE_MILESTONE,
  CREATE_MILESTONE_BULK,
  DELETE_MILESTONE,
  ADD_PAYMENT_RECEIVED,
  GET_FINANCE_PAYMENTS,
  CREATE_FINANCE_PAYMENT,
  GET_FINANCE_PAYMENT_DETAILS,
  UPDATE_FINANCE_PAYMENT,
  DELETE_FINANCE_PAYMENT,
  UPLOAD_FINANCE_PAYMENT_DOCUMENT,
  CREATE_TIMELINE_EXTENSION,
  UPLOAD_TIMELINE_EXTENSION_DOCUMENT,
  GET_NEGATIVE_COVENANTS,
  UPDATE_NEGATIVE_COVENANT,
  DELETE_NEGATIVE_COVENANT,
  UPLOAD_COVENANT_DOCUMENTS,
  UPLOAD_TASK_CREATE_DOCUMENTS,
  CREATE_SCHEDULE_EXTENSION,
  UPLOAD_EXTENSION_DOCUMENT,
  GET_SCHEDULE_EXTENSION_LIST,
  GET_SCHEDULE_EXTENSION,
  RESOLVE_TASK_UPDATE_ISSUE,
  DASHBOARD_FLAGGED_TASKS,
  DASHBOARD_TASK_STATISTICS,
  DASHBOARD_OBLIGATION_STATUS_STATISTICS,
  DASHBOARD_OBLIGATION_TYPE_STATISTICS,
  GET_SUB_CONTRACTS,
  COPY_RESPONSIBILITY,
  GET_PARENT_OBLIGATIONS,
  COPY_OBLIGATIONS,
  ADD_OBLIGATION_CLOSING_DETAILS,
  ADD_TASK_CLOSING_DETAILS,
  GET_COMMUNICATION,
  CREATE_COMMUNICATION,
  UPDATE_COMMUNICATION,
  UPLOAD_COMMUNICATION_DOCUMENT,
  DELETE_COMMUNICATION_DOCUMENT,
  GET_SUSPENSION_EVENTS,
  DELETE_SUSPENSION_EVENT,
  CREATE_SUSPENSION_EVENT,
  UPLOAD_SUSPENSION_EVENT_DOCUMENT,
  GET_SUSPENSION_DETAILS,
  GET_EVENT_UPDATES,
  CREATE_EVENT_UPDATE,
  UPDATE_EVENT_UPDATE,
  DELETE_EVENT_UPDATE_DOCUMENT,
  UPLOAD_EVENT_UPDATE_DOCUMENTS,
  RESOLVE_SUSPENSION_ISSUE,
  UPDATE_SUSPENSION_EVENT,
  DELETE_SUSPENSION_EVENT_DOCUMENT,
  LIST_CONTRACT_PERMISSION,
  GET_TASK_SCHEDULE_EXTENSIONS,
  CREATE_TASK_SCHEDULE_EXTENSION,
  UPDATE_TASK_SCHEDULE_EXTENSION,
  DELETE_TASK_SCHEDULE_EXTENSION,
  APPROVE_TASK_SCHEDULE_EXTENSION,
  UPLOAD_TASK_SCHEDULE_EXTENSION_DOCUMENT,
  GET_REPORTING_REMINDERS,
  CREATE_REPORTING_REMINDER,
  UPDATE_REPORTING_REMINDER,
  DELETE_REPORTING_REMINDER,
  GET_REPORTING_REMINDER_DETAILS,
  UPDATE_REMINDER_UPDATE,
  UPLOAD_REMINDER_UPDATE_DOCUMENT,
  DELETE_REMINDER_UPDATE_DOCUMENT,
  GET_PROJECT_TIMELINE,
  PROJECT_TIMELINE_ITEM,
  GET_DEVIATIONS,
  GET_DEVIATION,
  GET_DEVIATION_DETAILS,
  UPDATE_DEVIATION,
  GET_DEVIATION_FILTER_OPTIONS,
  CREATE_DEVIATION,
  UPLOAD_DEVIATION_DOCUMENT,
  DELETE_DEVIATION,
  DELETE_DEVIATION_DOCUMENT,
  FLOWCHART_EXPORT,
  FLOWCHART_GET,
} from "constants/ApiConstant";
import { createProgressHandler } from "utils/commonMethods";

const ContractService = {};

ContractService.getContracts = function (data) {
  return fetch({
    url: LIST_CONTRACTS,
    method: "get",
    params: data,
  });
};

ContractService.deleteContract = function (id) {
  return fetch({
    url: CONTRACT_DELETE(id),
    method: "delete",
  });
};

ContractService.addContract = function (data) {
  return fetch({
    url: CREATE_CONTRACTS,
    method: "post",
    data: data,
  });
};

ContractService.updateContract = function (id, data) {
  return fetch({
    url: CONTRACT_UPDATE(id),
    method: "put",
    data: data,
  });
};

ContractService.getContractDetails = function (id) {
  return fetch({
    url: CONTRACT_DETAILS(id),
    method: "get",
  });
};

ContractService.addRepository = function (id, data, options = {}) {
  return fetch({
    url: ADD_REPOSITORY(id),
    method: "post",
    data: data,
    timeout: 0,
    cancelToken: options.cancelToken,
    onUploadProgress: createProgressHandler(options.onProgress),
  });
};

ContractService.getRepository = function (id, params) {
  return fetch({
    url: GET_REPOSITORY(id),
    method: "get",
    params,
  });
};

ContractService.getRepositorySources = function (id) {
  return fetch({
    url: GET_REPOSITORY_SOURCES(id),
    method: "get",
  });
};

ContractService.deleteRepository = function (contractId, documentId) {
  return fetch({
    url: DELETE_REPOSITORY(contractId, documentId),
    method: "delete",
  });
};

ContractService.getResponsibility = function (contractId) {
  return fetch({
    url: GET_RESPONSIBILITY(contractId),
    method: "get",
  });
};

ContractService.addResponsibility = function (id, data) {
  return fetch({
    url: ADD_RESPONSIBILITY(id),
    method: "post",
    data: data,
  });
};

ContractService.copyresponsibility = function (id, data) {
  return fetch({
    url: COPY_RESPONSIBILITY(id),
    method: "post",
    data: data,
  });
};

ContractService.deleteResponsibility = function (contractId, id) {
  return fetch({
    url: DELETE_RESPONSIBILITY(contractId, id),
    method: "delete",
  });
};

ContractService.getObligations = function (contractId, params) {
  return fetch({
    url: GET_OBLIGATIONS(contractId),
    method: "get",
    params,
  });
};

ContractService.getParentObligation = function (contractId) {
  return fetch({
    url: GET_PARENT_OBLIGATIONS(contractId),
    method: "get",
  });
};

ContractService.copyObligation = function (contractId, data) {
  return fetch({
    url: COPY_OBLIGATIONS(contractId),
    method: "post",
    data: data,
  });
};

ContractService.addObligation = function (contractId, data) {
  return fetch({
    url: ADD_OBLIGATION(contractId),
    method: "post",
    data: data,
  });
};

ContractService.updateObligation = function (obligationId, data) {
  return fetch({
    url: UPDATE_OBLIGATION(obligationId),
    method: "patch",
    data: data,
  });
};

ContractService.deleteObligation = function (id) {
  return fetch({
    url: DELETE_OBLIGATION(id),
    method: "delete",
  });
};

ContractService.getObligationDetails = function (obligationId) {
  return fetch({
    url: GET_OBLIGATION_DETAILS(obligationId),
    method: "get",
  });
};

ContractService.getObligationTasks = function (obligationId, params) {
  return fetch({
    url: GET_OBLIGATION_TASKS(obligationId),
    method: "get",
    params,
  });
};

ContractService.addObligationClosingDetails = function (obligationId, payload) {
  return fetch({
    url: ADD_OBLIGATION_CLOSING_DETAILS(obligationId),
    method: "post",
    data: payload,
  });
};

ContractService.updateObligationPriority = function (obligationId, data) {
  return fetch({
    url: UPDATE_OBLIGATION_PRIORITY(obligationId),
    method: "patch",
    data: data,
  });
};

ContractService.getScheduleTasks = function (contractId, params) {
  return fetch({
    url: GET_SCHEDULE_TASKS(contractId),
    method: "get",
    params,
  });
};

ContractService.createScheduleTask = function (contractId, data) {
  return fetch({
    url: CREATE_SCHEDULE_TASK(contractId),
    method: "post",
    data: data,
  });
};

ContractService.addTaskClosingDetails = function (taskId, payload) {
  return fetch({
    url: ADD_TASK_CLOSING_DETAILS(taskId),
    method: "post",
    data: payload,
  });
};

ContractService.getMilestones = function (contractId, params) {
  return fetch({
    url: GET_MILESTONES(contractId),
    method: "get",
    params,
  });
};

ContractService.createMilestone = function (contractId, data) {
  return fetch({
    url: CREATE_MILESTONE(contractId),
    method: "post",
    data: data,
  });
};

ContractService.createMilestoneBulk = function (contractId, data) {
  return fetch({
    url: CREATE_MILESTONE_BULK(contractId),
    method: "post",
    data: data,
  });
};

ContractService.deleteMilestone = function (contractId, milestoneId) {
  return fetch({
    url: DELETE_MILESTONE(milestoneId),
    method: "delete",
  });
};

ContractService.addPaymentReceivedToMilestone = function (milestoneId, data) {
  return fetch({
    url: ADD_PAYMENT_RECEIVED(milestoneId),
    method: "post",
    data: data,
  });
};

ContractService.getFinancePayments = function (contractId, params) {
  return fetch({
    url: GET_FINANCE_PAYMENTS(contractId),
    method: "get",
    params,
  });
};

ContractService.createFinancePayment = function (contractId, data) {
  return fetch({
    url: CREATE_FINANCE_PAYMENT(contractId),
    method: "post",
    data: data,
  });
};

ContractService.getFinancePaymentDetails = function (paymentId) {
  return fetch({
    url: GET_FINANCE_PAYMENT_DETAILS(paymentId),
    method: "get",
  });
};

ContractService.updateFinancePayment = function (paymentId, data) {
  return fetch({
    url: UPDATE_FINANCE_PAYMENT(paymentId),
    method: "patch",
    data: data,
  });
};

ContractService.deleteFinancePayment = function (paymentId) {
  return fetch({
    url: DELETE_FINANCE_PAYMENT(paymentId),
    method: "delete",
  });
};

ContractService.uploadFinancePaymentDocument = function (contractId, formData) {
  return fetch({
    url: UPLOAD_FINANCE_PAYMENT_DOCUMENT(contractId),
    method: "post",
    data: formData,
  });
};

ContractService.getTaskDetails = function (taskId) {
  return fetch({
    url: GET_TASK_DETAILS(taskId),
    method: "get",
  });
};

ContractService.updateTask = function (taskId, data) {
  return fetch({
    url: UPDATE_TASK(taskId),
    method: "patch",
    data: data,
  });
};

ContractService.updateTaskPriority = function (taskId, data) {
  return fetch({
    url: UPDATE_TASK_PRIORITY(taskId),
    method: "patch",
    data: data,
  });
};

ContractService.deleteTask = function (taskId) {
  return fetch({
    url: DELETE_TASK(taskId),
    method: "delete",
  });
};

ContractService.getTaskUpdates = function (taskId, params) {
  return fetch({
    url: GET_TASK_UPDATES(taskId),
    method: "get",
    params,
  });
};

ContractService.createTaskUpdate = function (taskId, data) {
  return fetch({
    url: CREATE_TASK_UPDATE(taskId),
    method: "post",
    data: data,
  });
};

ContractService.updateTaskUpdate = function (updateId, data) {
  return fetch({
    url: UPDATE_TASK_UPDATE(updateId),
    method: "patch",
    data: data,
  });
};

ContractService.uploadTaskUpdateDocuments = function (
  updateId,
  formData,
  options = {},
) {
  return fetch({
    url: UPLOAD_TASK_UPDATE_DOCUMENTS(updateId),
    method: "post",
    data: formData,
    timeout: 0,
    cancelToken: options.cancelToken,
    onUploadProgress: createProgressHandler(options.onProgress),
  });
};

ContractService.deleteTaskUpdateDocument = function (documentId) {
  return fetch({
    url: DELETE_TASK_UPDATE_DOCUMENT(documentId),
    method: "delete",
  });
};

ContractService.uploadCreateTaskDocuments = function (
  taskId,
  formData,
  options = {},
) {
  return fetch({
    url: UPLOAD_TASK_CREATE_DOCUMENTS(taskId),
    method: "post",
    data: formData,
    timeout: 0,
    cancelToken: options.cancelToken,
    onUploadProgress: createProgressHandler(options.onProgress),
  });
};

ContractService.createTimelineExtension = function (obligationId, data) {
  return fetch({
    url: CREATE_TIMELINE_EXTENSION(obligationId),
    method: "post",
    data: data,
  });
};

ContractService.uploadTimelineExtensionDocument = function (
  timelineExtensionId,
  formData,
) {
  return fetch({
    url: UPLOAD_TIMELINE_EXTENSION_DOCUMENT(timelineExtensionId),
    method: "post",
    data: formData,
  });
};

ContractService.getNegativeCovenants = function (contractId, params) {
  return fetch({
    url: GET_NEGATIVE_COVENANTS(contractId),
    method: "get",
    params,
  });
};

ContractService.addNegativeCovenant = function (contractId, data) {
  return fetch({
    url: GET_NEGATIVE_COVENANTS(contractId),
    method: "post",
    data: data,
  });
};

ContractService.updateNegativeCovenant = function (covenantId, data) {
  return fetch({
    url: UPDATE_NEGATIVE_COVENANT(covenantId),
    method: "patch",
    data: data,
  });
};

ContractService.deleteNegativeCovenant = function (covenantId) {
  return fetch({
    url: DELETE_NEGATIVE_COVENANT(covenantId),
    method: "delete",
  });
};

ContractService.uploadCovenantDocuments = function (covenantId, formData) {
  return fetch({
    url: UPLOAD_COVENANT_DOCUMENTS(covenantId),
    method: "post",
    data: formData,
  });
};

ContractService.getScheduleExtensionList = function (contractId, params) {
  return fetch({
    url: GET_SCHEDULE_EXTENSION_LIST(contractId),
    method: "get",
    params,
  });
};

ContractService.createScheduleExtension = function (contractId, formData) {
  return fetch({
    url: CREATE_SCHEDULE_EXTENSION(contractId),
    method: "post",
    data: formData,
  });
};

ContractService.uploadExtensionDocument = function (extensionId, formData) {
  return fetch({
    url: UPLOAD_EXTENSION_DOCUMENT(extensionId),
    method: "post",
    data: formData,
  });
};

ContractService.getScheduleExtension = function (extensionId, params) {
  return fetch({
    url: GET_SCHEDULE_EXTENSION(extensionId),
    method: "get",
    params,
  });
};

ContractService.markResolved = function (updateId, data) {
  return fetch({
    url: RESOLVE_TASK_UPDATE_ISSUE(updateId),
    method: "post",
    data,
  });
};

ContractService.getFlaggedTasks = function (contactId, params) {
  return fetch({
    url: DASHBOARD_FLAGGED_TASKS(contactId),
    method: "get",
    params,
  });
};

ContractService.getTaskStatistics = function (contactId, param) {
  return fetch({
    url: DASHBOARD_TASK_STATISTICS(contactId),
    method: "get",
    param,
  });
};

ContractService.getObligationStatusStatistics = function (contactId, param) {
  return fetch({
    url: DASHBOARD_OBLIGATION_STATUS_STATISTICS(contactId),
    method: "get",
    param,
  });
};

ContractService.getObligationTypeStatistics = function (contactId, param) {
  return fetch({
    url: DASHBOARD_OBLIGATION_TYPE_STATISTICS(contactId),
    method: "get",
    param,
  });
};

ContractService.getSubContracts = function (contactId, filters) {
  return fetch({
    url: GET_SUB_CONTRACTS(contactId),
    method: "get",
    params: filters,
  });
};

ContractService.getTaskCommunications = function (taskId, filters = {}) {
  return fetch({
    url: GET_COMMUNICATION(taskId),
    method: "get",
    params: filters,
  });
};

ContractService.createCommunication = function (taskId, data) {
  return fetch({
    url: CREATE_COMMUNICATION(taskId),
    method: "post",
    data,
  });
};

ContractService.updateCommunication = function (comId, data) {
  return fetch({
    url: UPDATE_COMMUNICATION(comId),
    method: "patch",
    data,
  });
};

ContractService.uploadCommunicationDocument = function (
  comId,
  formData,
  options = {},
) {
  return fetch({
    url: UPLOAD_COMMUNICATION_DOCUMENT(comId),
    method: "post",
    data: formData,
    timeout: 0,
    cancelToken: options.cancelToken,
    onUploadProgress: createProgressHandler(options.onProgress),
  });
};

ContractService.deleteCommunicationDocument = function (documentId) {
  return fetch({
    url: DELETE_COMMUNICATION_DOCUMENT(documentId),
    method: "delete",
  });
};

ContractService.getSuspensionEvents = function (id, filters = {}) {
  return fetch({
    url: GET_SUSPENSION_EVENTS(id),
    method: "get",
    params: filters,
  });
};

ContractService.deleteSuspensionEvent = function (eventId) {
  return fetch({
    url: DELETE_SUSPENSION_EVENT(eventId),
    method: "delete",
  });
};

ContractService.createSuspensionEvent = function (contractId, data) {
  return fetch({
    url: CREATE_SUSPENSION_EVENT(contractId),
    method: "post",
    data,
  });
};

ContractService.updateSuspensionEvent = function (id, data) {
  return fetch({
    url: UPDATE_SUSPENSION_EVENT(id),
    method: "patch",
    data: data,
  });
};

ContractService.uploadSuspensionEventDocument = function (
  eventId,
  formData,
  options = {},
) {
  return fetch({
    url: UPLOAD_SUSPENSION_EVENT_DOCUMENT(eventId),
    method: "post",
    data: formData,
    timeout: 0,
    cancelToken: options.cancelToken,
    onUploadProgress: createProgressHandler(options.onProgress),
  });
};

ContractService.getSuspensionDetails = function (eventId) {
  return fetch({
    url: GET_SUSPENSION_DETAILS(eventId),
    method: "get",
  });
};

ContractService.getEventUpdates = function (eventId, filters = {}) {
  return fetch({
    url: GET_EVENT_UPDATES(eventId),
    method: "get",
    params: filters,
  });
};

ContractService.createEventUpdate = function (eventId, data) {
  return fetch({
    url: CREATE_EVENT_UPDATE(eventId),
    method: "post",
    data: data,
  });
};

ContractService.updateEventUpdate = function (updateId, data) {
  return fetch({
    url: UPDATE_EVENT_UPDATE(updateId),
    method: "patch",
    data: data,
  });
};

ContractService.uploadEventUpdateDocument = function (
  updateId,
  formData,
  options = {},
) {
  return fetch({
    url: UPLOAD_EVENT_UPDATE_DOCUMENTS(updateId),
    method: "post",
    data: formData,
    timeout: 0,
    cancelToken: options.cancelToken,
    onUploadProgress: createProgressHandler(options.onProgress),
  });
};

ContractService.deleteEventUpdateDocument = function (documentId) {
  return fetch({
    url: DELETE_EVENT_UPDATE_DOCUMENT(documentId),
    method: "delete",
  });
};

ContractService.resolveSuspensionEvent = function (updateId, data) {
  return fetch({
    url: RESOLVE_SUSPENSION_ISSUE(updateId),
    method: "post",
    data,
  });
};

ContractService.deleteSuspensionEventDocument = function (documentId) {
  return fetch({
    url: DELETE_SUSPENSION_EVENT_DOCUMENT(documentId),
    method: "delete",
  });
};

ContractService.getContractLevelPermissions = function (id) {
  return fetch({
    url: LIST_CONTRACT_PERMISSION(id),
    method: "get",
  });
};

ContractService.getTaskScheduleExtensions = function (taskId, params) {
  return fetch({
    url: GET_TASK_SCHEDULE_EXTENSIONS(taskId),
    method: "get",
    params,
  });
};

ContractService.createTaskScheduleExtension = function (taskId, data) {
  return fetch({
    url: CREATE_TASK_SCHEDULE_EXTENSION(taskId),
    method: "post",
    data: data,
  });
};

ContractService.getTaskScheduleExtensionDetails = function (extensionId) {
  return fetch({
    url: UPDATE_TASK_SCHEDULE_EXTENSION(extensionId),
    method: "get",
  });
};

ContractService.updateTaskScheduleExtension = function (extensionId, data) {
  return fetch({
    url: UPDATE_TASK_SCHEDULE_EXTENSION(extensionId),
    method: "patch",
    data: data,
  });
};

ContractService.deleteTaskScheduleExtension = function (extensionId) {
  return fetch({
    url: DELETE_TASK_SCHEDULE_EXTENSION(extensionId),
    method: "delete",
  });
};

ContractService.approveTaskScheduleExtension = function (extensionId) {
  return fetch({
    url: APPROVE_TASK_SCHEDULE_EXTENSION(extensionId),
    method: "post",
  });
};

ContractService.uploadTaskScheduleExtensionDocument = function (
  extensionId,
  formData,
  options = {},
) {
  return fetch({
    url: UPLOAD_TASK_SCHEDULE_EXTENSION_DOCUMENT(extensionId),
    method: "post",
    data: formData,
    timeout: 0,
    cancelToken: options.cancelToken,
    onUploadProgress: createProgressHandler(options.onProgress),
  });
};

ContractService.getReportingReminders = function (contractId, params) {
  return fetch({
    url: GET_REPORTING_REMINDERS(contractId),
    method: "get",
    params,
  });
};

ContractService.createReportingReminder = function (contractId, data) {
  return fetch({
    url: CREATE_REPORTING_REMINDER(contractId),
    method: "post",
    data,
  });
};

ContractService.updateReportingReminder = function (reminderId, data) {
  return fetch({
    url: UPDATE_REPORTING_REMINDER(reminderId),
    method: "patch",
    data,
  });
};

ContractService.deleteReportingReminder = function (reminderId) {
  return fetch({
    url: DELETE_REPORTING_REMINDER(reminderId),
    method: "delete",
  });
};

ContractService.getReportingReminderDetails = function (reminderId) {
  return fetch({
    url: GET_REPORTING_REMINDER_DETAILS(reminderId),
    method: "get",
  });
};

ContractService.updateReminderUpdate = function (updateId, data) {
  return fetch({
    url: UPDATE_REMINDER_UPDATE(updateId),
    method: "patch",
    data,
  });
};

ContractService.uploadReminderUpdateDocument = function (
  updateId,
  formData,
  options = {},
) {
  return fetch({
    url: UPLOAD_REMINDER_UPDATE_DOCUMENT(updateId),
    method: "post",
    data: formData,
    timeout: 0,
    cancelToken: options.cancelToken,
    onUploadProgress: createProgressHandler(options.onProgress),
  });
};

ContractService.deleteReminderUpdateDocument = function (documentId) {
  return fetch({
    url: DELETE_REMINDER_UPDATE_DOCUMENT(documentId),
    method: "delete",
  });
};

ContractService.getProjectTimeline = function (contractId, params) {
  return fetch({
    url: GET_PROJECT_TIMELINE(contractId),
    method: "get",
    params,
  });
};

ContractService.createProjectTimelineItem = function (contractId, data) {
  return fetch({
    url: GET_PROJECT_TIMELINE(contractId),
    method: "post",
    data: { data },
  });
};

ContractService.updateProjectTimelineItem = function (itemId, data) {
  return fetch({
    url: PROJECT_TIMELINE_ITEM(itemId),
    method: "patch",
    data: { data },
  });
};

ContractService.deleteProjectTimelineItem = function (itemId) {
  return fetch({
    url: PROJECT_TIMELINE_ITEM(itemId),
    method: "delete",
  });
};

ContractService.getDeviations = function (contractId, params) {
  return fetch({
    url: GET_DEVIATIONS(contractId),
    method: "get",
    params,
  });
};

ContractService.getDeviation = function (contractId, deviationId, params) {
  return fetch({
    url: GET_DEVIATION(contractId, deviationId),
    method: "get",
    params,
  });
};

ContractService.getDeviationFilterOptions = function () {
  return fetch({
    url: GET_DEVIATION_FILTER_OPTIONS,
    method: "get",
  });
};

ContractService.getDeviationDetails = function (contractId, deviationId) {
  return fetch({
    url: GET_DEVIATION_DETAILS(contractId, deviationId),
    method: "get",
  });
};

ContractService.createDeviation = function (contractId, data) {
  return fetch({
    url: CREATE_DEVIATION(contractId),
    method: "post",
    data,
  });
};

ContractService.updateDeviation = function (contractId, deviationId, data) {
  return fetch({
    url: UPDATE_DEVIATION(contractId, deviationId),
    method: "patch",
    data,
  });
};

ContractService.uploadDeviationDocument = function (contractId, formData, options) {
  return fetch({
    url: UPLOAD_DEVIATION_DOCUMENT(contractId),
    method: "post",
    data: formData,
    ...options,
  });
};

ContractService.deleteDeviation = function (contractId, deviationId) {
  return fetch({
    url: DELETE_DEVIATION(contractId, deviationId),
    method: "delete",
  });
};

ContractService.deleteDeviationDocument = function (contractId, documentId) {
  return fetch({
    url: DELETE_DEVIATION_DOCUMENT(contractId, documentId),
    method: "delete",
  });
};

ContractService.exportFlowchart = function (contractId) {
  return fetch({
    url: FLOWCHART_EXPORT(contractId),
    method: "post",
    data: {},
  });
};

ContractService.getFlowchart = function (contractId) {
  return fetch({
    url: FLOWCHART_GET(contractId),
    method: "get",
  });
};

export default ContractService;
